import { html, repeat, when } from '@microsoft/fast-element';
import type { IndividualProjectsOverview } from './individual-projects-overview';
import { getHtmlIconByName } from '../../../../styles';
import { starHighlightedIcon, starUnHighlightedIcon } from '../../../../styles/icons';
import { generateProjectDescription, PROJECT_OPERATIONAL_STATUS } from '../../../../utils';
export const IndividualProjectsOverviewTemplate = html<IndividualProjectsOverview>`
  <div class="individual-projects-overview">
    <zero-button
      slot="buttons"
      appearance="primary"
      class="watchlistButton"
      style="display: ${(x) => (x.showUncheckedWatchlist ? '' : 'none')}"
      @click=${(x) => x.updateProjectWatchList(true)}
    >
      ${starUnHighlightedIcon('start')} Add to Watchlist
    </zero-button>
    <zero-button
      slot="buttons"
      appearance="primary"
      class="watchlistButton"
      style="display: ${(x) => (x.showCheckedWatchlist ? '' : 'none')}"
      @click=${(x) => x.updateProjectWatchList(false)}
    >
      ${starHighlightedIcon('start')} Remove from Watchlist
    </zero-button>
    <div class="title">
      <span class="tile-title">${(x) => x.project?.NAME}</span>
      <span class="tile-sub-title">${(x) => x.project?.CASCADE_COMPANY_NAME}</span>
    </div>
    <div class="row">
      ${repeat(
        (x) => x.tileList,
        html`
          <tile-card :title=${(x) => x.title}>
            ${repeat(
              (x) => x.items,
              html`
                ${when(
                  (x) => x.icon,
                  html`
                    <span>${(x) => getHtmlIconByName(x.icon)}</span>
                  `,
                )}
                <span>${(x) => x.value}</span>
              `,
            )}
          </tile-card>
        `,
      )}
    </div>
    <div class="box">
      <div class="description">${(x) => generateProjectDescription(x.project)}</div>
      <div
        class=${(x) =>
          x.project?.PROJECT_OPERATIONAL_STATUS === PROJECT_OPERATIONAL_STATUS.NEW_BUILD
            ? 'table-columns'
            : 'single-column'}
      >
        <table>
          <tr>
            <th class="overview-table-header">General Information</th>
          </tr>
          ${repeat(
            (x) => x.generalInformation,
            html`
              <tr>
                <td class="table-row">
                  <span class="left-span">${(x) => x.title}</span>
                  <span class="right-span">${(x) => x.value}</span>
                </td>
              </tr>
            `,
          )}
        </table>
      </div>

      ${when(
        (x) => x.project?.PROJECT_OPERATIONAL_STATUS === PROJECT_OPERATIONAL_STATUS.NEW_BUILD,
        html`
          <div class="table-columns">
            <table>
              <tr>
                <th class="overview-table-header">Contracts and Reports</th>
              </tr>
              ${repeat(
                (x) => x.contractsAndReports,
                html`
                  <tr>
                    <td class="table-row">
                      <span class="left-span">${(x) => x.title}</span>
                      <div class="right-span-button" id="${(x) => x.buttonType}">
                        ${(x) => x.value}
                      </div>
                    </td>
                  </tr>
                `,
              )}
            </table>
          </div>
          <div class="table-columns">
            <table>
              <tr>
                <th class="overview-table-header">Permits / Government Approvals</th>
              </tr>
              ${repeat(
                (x) => x.permitsGovernmentApprovals,
                html`
                  <tr>
                    <td class="table-row">
                      <span class="left-span">${(x) => x.title}</span>
                      <div class="right-span-button" id="${(x) => x.buttonType}">
                        ${(x) => x.value}
                      </div>
                    </td>
                  </tr>
                `,
              )}
            </table>
          </div>
        `,
      )}
    </div>
  </div>
`;
